import React from "react";
import { Card, CardContent, Typography, Box } from "@material-ui/core";

import {
  CheckCircle,
  ErrorOutline,
  HourglassEmpty,
  Assignment,
} from "@material-ui/icons";

const STATUS = {
  0: {
    title: "احراز هویت انجام نشده",
    message:
      "هنوز اطلاعات احراز هویت خود را تکمیل نکرده‌اید. برای افزایش اعتبار حساب، فرم زیر را تکمیل کنید.",
    color: "#9E9E9E",
    background: "#F7F7F7",
    border: "#E0E0E0",
    icon: Assignment,
  },

  1: {
    title: "در انتظار بررسی",
    message:
      "اطلاعات شما ثبت شده و پس از بررسی کارشناسان نتیجه اعلام خواهد شد.",
    color: "#F9A825",
    background: "#FFF8E1",
    border: "#FFD54F",
    icon: HourglassEmpty,
  },

  2: {
    title: "احراز هویت تایید شده",
    message:
      "حساب کاربری شما تایید شده و می‌توانید با اعتبار بیشتری از سامانه استفاده کنید.",
    color: "#2E7D32",
    background: "#E8F5E9",
    border: "#81C784",
    icon: CheckCircle,
  },

  3: {
    title: "احراز هویت رد شده",
    message:
      "مدارک ارسالی مورد تایید قرار نگرفت. لطفاً اطلاعات خود را اصلاح و دوباره ارسال کنید.",
    color: "#D32F2F",
    background: "#FDECEC",
    border: "#EF9A9A",
    icon: ErrorOutline,
  },
};

export default function VerificationStatus({ status, rejectReason }) {
  const data = STATUS[status];

  const Icon = data.icon;

  return (
    <Card
      elevation={0}
      style={{
        marginBottom: 24,
        borderRadius: 14,
        background: data.background,
        border: `1px solid ${data.border}`,
      }}
    >
      <CardContent>
        <Box display="flex" alignItems="center">
          <Icon
            style={{
              color: data.color,
              fontSize: 34,
            }}
          />

          <Box ml={2}>
            <Typography
              style={{
                fontWeight: 700,
                color: data.color,
              }}
            >
              {data.title}
            </Typography>

            <Typography
              style={{
                marginTop: 5,
                color: "#555",
                lineHeight: 1.8,
              }}
            >
              {data.message}
            </Typography>

            {status === 3 && rejectReason && (
              <Typography
                style={{
                  marginTop: 12,
                  color: "#C62828",
                  fontWeight: 600,
                }}
              >
                دلیل رد شدن: {rejectReason}
              </Typography>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
